const { produce } = require("immer");

const init = {
  uid: null,
  projectUid: null,
  licences: [],
  roles: []
}

module.exports = function(state = init, action) {
  switch (action.type) {
    case "SET_licenceAndRoleForm":
      return produce(state, draft => {
        Object.assign(draft, init, action.form);
      });

    case "UPDATE_licenceAndRoleForm":
      return produce(state, draft => {
        Object.assign(draft, action.form);
      });

    case "REMOVE_LICENCE_licenceAndRoleForm":
      return produce(state, draft => {

        draft.roles.forEach(role => {
          delete role.licences[action.key]
        })
        draft.licences = action.licences;
      });

    case "ADD_LICENCE_licenceAndRoleForm":
      return produce(state, draft => {
        draft.roles.forEach(role => {
          role.licences[action.key] = action.right
        })

        draft.licences = action.licences;
      });

    case "ADD_ROLE_licenceAndRoleForm":
      return produce(state, draft => {

        let lic = {};

        draft.licences.forEach(uid => {
          lic[uid] = action.licencesForRights[uid].rights[0];
        })

        draft.roles.push({
          name: action.name,
          project: state.projectUid,
          licences: lic
        })
      });

    case "REMOVE_ROLE_licenceAndRoleForm":
      return produce(state, draft => {
        draft.roles = draft.roles.filter((role) => {
          return role.name !== action.name;
        });
      });

    case "UPDATE_ROLE_licenceAndRoleForm":
      return produce(state, draft => {

        draft.roles.forEach(role => {
          if (role.name === action.role) {
            //delete role.licences[action.licence];
            role.licences[action.licence] = action.value;
          }
        })

      });

    case "RESET_licenceAndRoleForm":
      return init;

    default:
      return state;
  }
}